module.exports = __webpack_public_path__ + "img/coach.ab68da33.svg";